import CancelButton from '@/features/common/buttons/CancelButton'
import ConfirmButton from '@/features/common/buttons/ConfirmButton'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { StyleSheet, View } from 'react-native'

interface CancelOrderDialogActionButtonsProps {
    confirmLoading: boolean
    onConfirm: () => Promise<void>
    onCancel: () => void
}

const CancelOrderDialogActionButtons: FC<CancelOrderDialogActionButtonsProps> = ({
    confirmLoading,
    onConfirm,
    onCancel,
}) => {
    const { t } = useTranslation()

    return (
        <View style={styles.container}>
            <ConfirmButton
                disabled={confirmLoading}
                loading={confirmLoading}
                label={t('order.detail.cancelDialog.confirmAction')}
                onConfirm={onConfirm}
            />
            <CancelButton
                disabled={confirmLoading}
                label={t('order.detail.cancelDialog.cancelAction')}
                onPress={onCancel}
            />
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        marginTop: 8,
        gap: 16,
    },
})

export default CancelOrderDialogActionButtons
